import React from "react";
import "../componentsStyle.scss";
import { contactInformationLabel } from "../../constants/translations";
import { EmailSvg, LocationSvg, PhoneLogo, TimeSvg } from "../../assets/svg";
import { email, hours, location, phone } from "../../constants/appConstats";
import {
  openFooterEmail,
  openFooterWhatsApp,
  openLocationInMaps,
} from "../../helpers/Helper";

export const ContactInformation = ({ languageId }) => {
  return (
    <div className="contactInformation">
      <div className="label">
        {contactInformationLabel[languageId]?.label || "Contact Information"}
      </div>

      <div className="item" onClick={() => openFooterWhatsApp(languageId)}>
        <div className="logo">
          <PhoneLogo width={32} height={32} />
        </div>
        <div className="info">
          <div className="title">Phone</div>
          <div className="des">{phone}</div>
        </div>
      </div>
      <div className="item" onClick={() => openFooterEmail({ languageId })}>
        <div className="logo">
          <EmailSvg width={32} height={32} />
        </div>
        <div className="info">
          <div className="title">Email</div>
          <div className="des">{email}</div>
        </div>
      </div>
      <div className="item" onClick={() => openLocationInMaps()}>
        <div className="logo">
          <LocationSvg width={32} height={32} />
        </div>
        <div className="info">
          <div className="title">Address</div>
          <div className="des">{location}</div>
        </div>
      </div>
      <div className="item">
        <div className="logo">
          <TimeSvg width={32} height={32} />
        </div>
        <div className="info">
          <div className="title">Working Hours</div>
          <div className="des">{hours}</div>
        </div>
      </div>
    </div>
  );
};
